<template>
	<div class="dispatchStatisticsData">
    <span>Total load:
      <span class="green-text">{{ dispatchData.dispatchTotalLoad }}</span>
    </span>
		<span>Total gross:
      <span class="green-text">{{ dispatchData.dispatchAmount }}</span>
		</span>
		<span>Quantity of trucks:
      <span class="green-text">{{ dispatchData.dispatchTotalTruck }}</span>
		</span>
	</div>
</template>
<script>
export default {
	name: "DispatchStatisticsData",
	props: {
		dispatchData: Object,
	},
};
</script>

<style scoped lang="scss">
.dispatchStatisticsData {
	display: flex;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
	flex-grow: 1;
	justify-content: space-between;
	color: var(--card-color);

	span {
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: 20px;
		letter-spacing: 0.25px;

		.green-text {
			color: var(--base-green);
		}
	}
}

</style>
